import { runQuery } from '../../fetchUtils'

const fetchAllRosters = callbacks => {
  const query =
  `query fetchRosters {
    courses {
      id
      name
      sections {
        id
        name
        registrationCode
        students {
          id
        }
      }
    }
  }`
  runQuery(query, {}, callbacks)
}

const fetchSection = (callbacks, vars) => {
  const query =
  `query fetchSection($id: ID!) {
    courses {
      id
      name
    }
    section(id: $id) {
      id
      name
      description
      isCodeActive
      registrationCode
      course {
        id
        name
      }
      students {
        id
        profile {
          uuid
          firstName
          lastName
          email
          username
          password
          characterName
        }
        hasCompletedQuestProgress
      }
    }
  }`
  runQuery(query, vars, callbacks)
}

const createSection = (callbacks, vars) => {
  const query =
  `mutation CreateSection($name: String, $courseName: String, $courseId: ID, $description: String) {
    createSection(name: $name, courseName: $courseName, courseId: $courseId, description: $description) {
      section {
        id
      }
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

const updateSection = (callbacks, vars) => {
  const query =
  `mutation UpdateSection($id: ID!, $name: String, $description: String, $courseId: ID, $courseName: String, $studentProfiles: [StudentProfilesAttributes!], $isCodeActive: Boolean) {
    updateSection(id: $id, name: $name, description: $description, courseId: $courseId, courseName: $courseName, studentProfiles: $studentProfiles, isCodeActive: $isCodeActive) {
      section {
        id
        name
        description
        registrationCode
        isCodeActive
        course {
          id
          name
        }
        students {
          id
          profile {
            uuid
            firstName
            lastName
            username
            email
            password
          }
        }
      }
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

const upsertStudents = (callbacks, vars) => {
  const query =
  `mutation upsertStudents($sectionId: ID!, $studentProfiles: [StudentProfilesAttributes!]!) {
    upsertStudents(sectionId: $sectionId, studentProfiles: $studentProfiles) {
      section {
        id
        name
        description
        registrationCode
        course {
          id
          name
        }
        students {
          id
          profile {
            uuid
            firstName
            lastName
            username
            email
            password
          }
        }
      }
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

const updateCourse = (callbacks, vars) => {
  const query =
  `mutation UpdateCourse($id: ID!, $name: String) {
    updateCourse(id: $id, name: $name) {
      course {
        id
        name
        sections {
          id
          name
          registrationCode
          students {
            id
          }
        }
      }
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

const resetPasswords = (callbacks, vars) => {
  const query =
  `mutation resetPasswords($sectionId: ID!) {
    resetStudentPasswords(sectionId: $sectionId) {
      section {
        id
        name
        description
        registrationCode
        course {
          id
          name
        }
        students {
          id
          profile {
            uuid
            firstName
            lastName
            username
            email
            password
          }
        }
      }
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

const fetchGoogleClassrooms = callbacks => {
  const query =
  `query fetchGoogleClassrooms {
    googleSections{
      sections {
        id
        name
        studentCount
      }
      authorizationLink
    }
  }`
  runQuery(query, {}, callbacks)
}

const importGoogleClassroomStudents = (callbacks, vars) => {
  const query =
  `mutation importClassroom($classroomId: ID!, $sectionId: ID!) {
    importGoogleClassroomStudents(classroomId: $classroomId, sectionId: $sectionId) {
      section {
        id
        name
        description
        registrationCode
        course {
          id
          name
        }
        students {
          id
          profile {
            uuid
            firstName
            lastName
            username
            email
            password
          }
        }
      }
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

const deleteStudents = (callbacks, vars) => {
  const query =
  `mutation DeleteStudents($studentIds: [ID!]!){
    deleteStudents(ids: $studentIds){
      deletedUsersCount
      unenrolledUsersCount
    }
  }`
  runQuery(query, vars, callbacks)
}

const transferStudents = (callbacks, vars) => {
  const query =
  `mutation transferStudents($studentIds: [ID!]!, $sectionId: ID, $sectionName: String, $sectionDescription: String, $courseId: ID, $courseName: String){
    transferStudents(studentIds: $studentIds, sectionId: $sectionId, sectionName: $sectionName, sectionDescription: $sectionDescription, courseId: $courseId, courseName: $courseName){
      targetSectionId
      transferredStudentsCount
      errors
    }
  }`
  runQuery(query, vars, callbacks)
}

export default { fetchAllRosters, fetchSection, updateCourse, createSection, updateSection, upsertStudents, fetchGoogleClassrooms, importGoogleClassroomStudents, resetPasswords, deleteStudents, transferStudents }
